// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"mouse"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M5 10H19V15C19 18.866 15.866 22 12 22C8.13401 22 5 18.866 5 15V10Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M19 10V15C19 18.866 15.866 22 12 22C8.13401 22 5 18.866 5 15V10M19 10H12M19 10V9C19 5.13401 15.866 2 12 2M5 10H12M5 10V9C5 5.13401 8.13401 2 12 2M12 10V2","strokeWidth":"props.strokeWidth"}}]}]};

const MouseIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'mouse',
    ref,
    icon: element,
  },
));

MouseIcon.displayName = 'MouseIcon';

export default MouseIcon;
